import {Mapper} from '@s-ui/domain'

export class RelatedSubscriptionAdsRequestValueObjectMapper extends Mapper {
  /**
   * @constructor
   * @param {Config} config
   ** @param {Function} relatedAdsRequestValueObjectFactory
   */
  constructor({config, relatedAdsRequestValueObjectFactory}) {
    super()
    this._config = config
    this._relatedAdsRequestValueObjectFactory = relatedAdsRequestValueObjectFactory
    this._defaultCount = this._config.get('search').DEFAULT_RELATED_ADS_COUNT
  }

  map = ({modelId, count, context} = {}) => {
    return this._relatedAdsRequestValueObjectFactory({
      modelId,
      count: count || this._defaultCount,
      subscriptionContext: context
    })
  }
}
